<template>
  <div class="modal-overlay" v-if="abrirModal == true">
    <div class="modal-content">
      <div class="modal-icon">
        <div class="outer-circle"></div>
        <div class="middle-circle"></div>
        <div class="inner-circle">
          <div class="inner-border">!</div>
        </div>
      </div>
      <div class="modal-header">
        <h4 style="margin-top: 10px; margin-bottom: 20px">Atenção!</h4>
      </div>
      <div class="modal-body">
        <p>{{ mensagem }}<br /></p>
        <p v-if="mensagensComplementares != ''">
          {{ mensagensComplementares }}
        </p>
        <br />
      </div>
      <div class="modal-footer">
        <button @click="closeModal">Entendi</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["mensagem", "mensagensComplementares"],
  computed: {
    ...mapGetters({
      abrirModal: "GET_MODAL_AVISO_GENERICO",
    }),
  },
  methods: {
    closeModal() {
      this.$store.commit("SET_MODAL_AVISO_GENERICO", false);
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  width: 300px;
  padding: 20px;
  background: white;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
}

.modal-icon {
  margin-bottom: -10px;
  position: relative;
}

.outer-circle {
  width: 40px;
  height: 40px;
  background: #fceae3;
  border-radius: 50%;
  position: relative;
}

.middle-circle {
  width: 30px;
  height: 30px;
  background: #f9d5c5;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.inner-circle {
  width: 24px;
  height: 24px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.inner-border {
  width: 20px;
  height: 20px;
  border: 2px #ec7644 solid;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #ec7644;
  font-weight: bold;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.modal-header {
  margin-bottom: -10px;
  color: #00235c;
  font-size: 18px;
  font-family: Inter;
  font-weight: 600;
}

.modal-body {
  color: #808184;
  font-size: 14px;
  font-family: Inter;
  font-weight: 400;
  margin-bottom: 20px;
}

.modal-footer {
  width: 100%;
}

.modal-footer button {
  width: 100%;
  padding: 10px;
  background: #878e94;
  color: white;
  font-size: 14px;
  font-family: Inter;
  font-weight: 500;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  text-align: center;
}

.modal-footer button:hover {
  background: #6c757d;
}

.highlight {
  font-weight: 600;
}
</style>
